import React, { Component } from 'react';
import logo from '../images/logo.svg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { auth } from '../firebase';

require('./index.css');

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: null
    }
  }

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { email } = this.state;

    auth.doPasswordReset(email)
    .then(() => {
      this.setState({ 
        email: '',
        error: null 
      });
      this.props.push('/login');      
    })
    .catch(error => {
      this.setState({
        error: error
      });
    });
  }

  render() {
    const {
      email,
      error
    } = this.state;

    const isInvalid = email === '';

    return (
        <div className='card text-white bg-primary mb-3'>
            <div className='card-header'>
              <div>
                <img src={logo} className='login-logo' alt='nerve-logo' />
                  NeuroSchematic &nbsp;
                <i className='fa fa-registered'></i>
              </div>
              <div style={{ fontSize: 20, paddingTop: 5 }}>Reset Password</div>
            </div>
            <div className='card-body'>
                <form onSubmit={ this.handleSubmit }>

                  <div className='form-group'>
                    <label htmlFor='email'>Enter Your Email</label>
                    <input 
                      type='email' 
                      className='form-control' 
                      id='email' 
                      placeholder='Enter Email' 
                      value={ email }
                      onChange={ this.handleEmailChange } />
                  </div>
                  <h6 style={{ lineHeight: '2em' }}>Please check your email. A will receive instructions to reset with a new password.</h6>
                  
                  <button disabled={isInvalid} type='submit' className='btn btn-secondary'>
                    Reset Password
                  </button>

                  { error && <p style={{ color: '#f46b42'}}>{error.message}</p> }

                </form>
            </div>
        </div>
    );
  }
}

//-----Redux Functions-----
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ push }, dispatch); 
};

export default connect(null, mapDispatchToProps)(ForgetPassword);


// WEBPACK FOOTER //
// ./src/forgetPassword/index.js